import React, { useEffect } from 'react';

const Survey = () => {
  console.log('🔍 Survey component rendering...');
  
  useEffect(() => {
    console.log('🔍 Survey component mounted - useEffect running!');
    
    // Determine the survey URL based on environment
    let surveyUrl;
    
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      // Local development - redirect to backend server on port 5001
      surveyUrl = '/survey';
    } else {
      // Production/deployed - the survey route is handled by the same server
      // Just redirect to /survey on the current domain/protocol
      surveyUrl = '/survey';
    }
    
    console.log('🔄 About to redirect to survey:', surveyUrl);
    console.log('🔄 Current URL:', window.location.href);
    
    // Immediate redirect without delay
    window.location.replace(surveyUrl);
  }, []);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontFamily: 'Arial, sans-serif',
      fontSize: '18px',
      color: '#666',
      backgroundColor: '#f8f9fa'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h1>Survey Component Loaded!</h1>
        <div style={{ marginBottom: '20px' }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '3px solid #f3f3f3',
            borderTop: '3px solid #3498db',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto'
          }}></div>
        </div>
        <p>Redirecting to survey...</p>
        <p style={{ fontSize: '14px', color: '#999', marginTop: '10px' }}>
          If you're not redirected automatically, <a href="/survey" style={{ color: '#3498db' }}>click here</a>
        </p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Survey;
